// Registro de modificaciones: qué se tocó, cuándo y quién.
// Se escribe solo desde el middleware; acá sólo se lee.

import { api } from "../api";
import { esc } from "../html";
import { formatoLocal, hoyMontevideo, sumarDias } from "../../lib/fecha";

interface Movimiento {
  id: number;
  usuario: string;
  metodo: string;
  entidad: string | null;
  entidad_id: number | null;
  detalle: string;
  fecha: string; // 'YYYY-MM-DD HH:MM:SS' en hora de Montevideo
}

const COLOR_METODO: Record<string, string> = {
  POST: "chip chip-ok",
  PUT: "chip chip-acento",
  DELETE: "chip chip-alerta",
};

const ETIQUETA_METODO: Record<string, string> = {
  POST: "alta",
  PUT: "cambio",
  DELETE: "baja",
};

/** El día de hoy y el de ayer se nombran, el resto va con fecha. */
function tituloDia(dia: string, hoy: string): string {
  if (dia === hoy) return "Hoy";
  if (dia === sumarDias(hoy, -1)) return "Ayer";
  return formatoLocal(dia);
}

export async function renderAuditoria(contenedor: HTMLElement): Promise<void> {
  try {
    const movimientos = await api.get<Movimiento[]>("/api/auditoria");
    const hoy = hoyMontevideo();

    // Agrupado por día, que es como uno se acuerda de las cosas.
    const dias: { dia: string; lista: Movimiento[] }[] = [];
    for (const m of movimientos) {
      const dia = m.fecha.slice(0, 10);
      const ultimo = dias[dias.length - 1];
      if (ultimo && ultimo.dia === dia) ultimo.lista.push(m);
      else dias.push({ dia, lista: [m] });
    }

    contenedor.innerHTML = `
      <h1 class="titulo-pagina">Registro</h1>
      <p class="subtitulo">Todo lo que cambió en la app, de lo más nuevo a lo más viejo.</p>

      ${
        movimientos.length
          ? dias
              .map(
                (d) => `
        <section class="mt-5">
          <h2 class="mb-2 text-sm font-semibold uppercase tracking-wider text-apagado">
            ${tituloDia(d.dia, hoy)}
          </h2>
          <div class="space-y-1.5">
            ${d.lista
              .map(
                (m) => `
              <div class="fila flex items-start gap-3 p-3">
                <span class="w-11 shrink-0 pt-0.5 font-mono text-xs text-apagado">${m.fecha.slice(11, 16)}</span>
                <span class="min-w-0 flex-1 break-words text-sm">${esc(m.detalle)}</span>
                <span class="${COLOR_METODO[m.metodo] ?? "chip"} shrink-0">${
                  ETIQUETA_METODO[m.metodo] ?? esc(m.metodo)
                }</span>
              </div>`,
              )
              .join("")}
          </div>
        </section>`,
              )
              .join("")
          : `<div class="tarjeta mt-4 text-center text-apagado">
               Todavía no hay movimientos registrados.
             </div>`
      }

      ${
        movimientos.length >= 200
          ? `<p class="mt-4 text-xs text-apagado">Se muestran los últimos 200 movimientos.</p>`
          : ""
      }`;
  } catch (e) {
    contenedor.innerHTML = `<div class="tarjeta text-alerta">No se pudo cargar el registro: ${esc(
      e instanceof Error ? e.message : "error desconocido",
    )}</div>`;
  }
}
